module.exports = __webpack_public_path__ + "img/nodata.e613bf1b.png";